var map = {
	"./goldcoin/index-icon-squad.png": 83458,
	"./memetown/index-icon-squad.png": 29563,
	"./reflection/index-icon-squad.png": 38825,
	"./tapcoin/index-icon-squad.png": 21273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52771;